export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50];

export function parseDelimitedProducts(dataString) {
  if (!dataString) {
    return [];
  }

  return dataString
    .split(/\r?\n/)
    .filter((line) => line.trim())
    .map((line, index) => {
      const parts = line.split('\t');
      if (parts.length < 4) {
        throw new Error(`Invalid product row at line ${index + 1}`);
      }

      return {
        ean: parts[0].trim(),
        product_name: parts[1].trim(),
        store_code: parts[2].trim(),
        internal_code: parts[3].trim(),
      };
    });
}

export function parseDelimitedScans(dataString) {
  if (!dataString) {
    return [];
  }

  return dataString
    .split(/\r?\n/)
    .filter((line) => line.trim())
    .map((line, index) => {
      const parts = line.split('\t');
      if (parts.length < 6) {
        throw new Error(`Invalid scan row at line ${index + 1}`);
      }

      return {
        ean: parts[0].trim(),
        product_name: parts[1].trim(),
        quantity: Number(parts[2]) || 1,
        scanned_by_name: parts[3].trim(),
        scanned_at: parts[4].trim(),
        device_id: parts[5].trim(),
        // 7th column from servers that store status; older data was all valid.
        status: (parts[6] || '').trim() === 'invalid' ? 'invalid' : 'valid',
        // 8th column: rack / shelf location (blank for older app versions).
        location: (parts[7] || '').trim(),
        // 9th-11th: an invalid scan the store team resolved (original EAN, by, when).
        original_ean: (parts[8] || '').trim(),
        corrected_by_name: (parts[9] || '').trim(),
        corrected_at: (parts[10] || '').trim(),
      };
    });
}

export function formatScanTime(value) {
  if (!value) {
    return '—';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleString();
}
